<template>
  <div class="FarmCropImage crop-item">
    <BaseTag
      :key="`${value}-${slug}`"
      background="#DAEBE1"
      show-icon
      round
    >
      <template #icon>
        <BaseImage
          :key="`${value}-${slug}`"
          force
          loading="lazy"
          class="crop-item__icon"
          :src="require(`images/icons/crops-icons/${iconPathName}.svg`)"
          :alt="iconPathName"
        />
      </template>
      {{ value }}
    </BaseTag>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { BaseTag } from 'Components/Base/BaseTag';
import BaseImage from 'Components/Base/BaseImage.vue';

export default defineComponent({
  name: 'FarmCropImage',
  components: {
    BaseImage,
    BaseTag,
  },
  props: {
    value: {
      type: String,
      default: 'default',
    },
    slug: String,
  },
  setup(props) {
    const iconsList = [
      { value: ['pinto & kidney beans', 'pinto & kidney bean', 'peas', 'pea'], icon: 'pinto' },
      { value: ['cotton', 'cottons'], icon: 'cotton' },
      { value: ['melon', 'melons'], icon: 'melon' },
      { value: ['cherry', 'cherries'], icon: 'cherry' },
      { value: ['apple', 'apples'], icon: 'apple' },
      { value: ['peanut', 'peanuts'], icon: 'peanut' },
      { value: ['almond', 'almonds'], icon: 'almond' },
      { value: ['corn', 'corns'], icon: 'corn' },
      { value: ['peas', 'soybean', 'soybeans'], icon: 'soybean' },
      { value: ['sorghum', 'sorghums', 'rice', 'rices'], icon: 'sorghum' },
      { value: ['potato', 'potatoes'], icon: 'potato' },
      { value: ['carrot', 'carrots'], icon: 'carrot' },
      { value: ['pecan', 'pecans'], icon: 'pecan' },
      { value: ['barley', 'barleys'], icon: 'barley' },
      { value: ['sunflower', 'sunflowers'], icon: 'sunflower' },
      { value: ['mandarins', 'mandarin'], icon: 'mandarin' },
      { value: ['lemons', 'lemon'], icon: 'lemon' },
      { value: ['avocado', 'avocados'], icon: 'avocado' },
      { value: ['olives', 'olive'], icon: 'olives' },
      { value: ['walnut', 'walnuts'], icon: 'walnut' },
      { value: ['hops'], icon: 'hops' },
      { value: ['pistachio', 'pistachios'], icon: 'pistachio' },
      { value: ['sugar beet', 'sugar beets'], icon: 'sugar-beet' },
      { value: ['onions', 'onion'], icon: 'onions' },
      { value: ['timber'], icon: 'timber' },
      { value: ['mixed vegetables'], icon: 'mixed-vegetables' },
      { value: ['wheat', 'wheats'], icon: 'wheat' },
      { value: ['grass seed', 'grass seeds'], icon: 'grass-seed' },
      { value: ['citrus'], icon: 'citrus' },
      { value: ['wine grape', 'wine grapes'], icon: 'wine-grapes' },
    ];

    const iconPathName = computed(() => {
      const icon = iconsList.find(item => item.value.includes(props.value.toLowerCase()));
      return icon?.icon || 'alfalfa';
    });

    return {
      iconPathName,
    };
  },
});
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.crop-item
  position: relative
  z-index: 0
  &__icon
    position: relative
    z-index: 2
    width: 16px
    height: 16px
    padding: 2px
</style>
